import ApiClient from '@package/services/src/ApiClient';
import Result, { EmptyResult } from '@package/services/src/Result';

import { CouponCodeService } from './services';
import { CouponCode, CouponCodeRequest, GetCouponCodeRequest } from './types';

export default class CouponCodeApiService implements CouponCodeService {
  public constructor(private readonly apiClient: ApiClient) {}

  public async getCouponCode(request?: GetCouponCodeRequest): Promise<Result<CouponCode | null>> {
    try {
      const res = await this.apiClient.get('/shoppingCart/coupons', {
        credentials: request?.cookie ? 'include' : undefined,
        headers: request?.cookie ? { Cookie: request.cookie } : undefined,
      });
      const json = await res.json();

      return new Result(json);
    } catch (error) {
      console.error('Unable to get coupon code', error);
      return new Result(null);
    }
  }

  public async applyCouponCode(request: CouponCodeRequest): Promise<Result<boolean | undefined>> {
    const { couponCode } = request;

    const res = await this.apiClient.post('/shoppingCart/couponCodes', {
      body: { couponCode: couponCode.trim() },
    });

    if (res.status === 200) {
      return new Result(true);
    }

    return new Result(undefined);
  }

  public async deleteCouponCode(request: CouponCodeRequest): Promise<EmptyResult | undefined> {
    const { couponCode } = request;

    try {
      await this.apiClient.delete('/shoppingCart/coupons', {
        body: { couponCode: couponCode.trim() },
      });

      return new EmptyResult();
    } catch (error) {
      console.error('Unable to delete coupon code', error);
    }
  }
}
